/**
 * Alerts & toasts — shared types.
 *
 * This module is the copy *source of truth*: components should look strings
 * up by id here instead of authoring copy inline at the call site.
 */

/** The four dedicated alert meanings. Never reused for brand/badge/category color. */
export type AlertVariant = 'success' | 'error' | 'warning' | 'info'

export interface AlertCopyEntry {
  variant: AlertVariant
  /** The outcome, sentence case, no ending punctuation. Aim for <= 40 chars. */
  title: string
  /** Optional secondary line — the specific object, or the next step for errors. Aim for <= 80 chars. */
  description?: string
  /**
   * ms before auto-dismiss. Omit to require manual dismissal — this is the
   * default (and the rule) for `variant: 'error'`, since a failure the user
   * didn't get to read before it vanished is worse than no toast at all.
   */
  duration?: number
}

/** Fallback durations by variant, used when an entry doesn't specify its own. */
export const DEFAULT_ALERT_DURATIONS: Record<AlertVariant, number | undefined> = {
  success: 3200,
  info: 3200,
  warning: 4200,
  // Errors don't auto-dismiss by default — see AlertCopyEntry.duration doc above.
  error: undefined,
}
